import { render } from "./OrganizationChartWidget.vue?vue&type=template&id=2eecd92f&scoped=true"
import script from "./OrganizationChartWidget.vue?vue&type=script&lang=js"
export * from "./OrganizationChartWidget.vue?vue&type=script&lang=js"

import "./OrganizationChartWidget.vue?vue&type=style&index=0&id=2eecd92f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eecd92f"]])

export default __exports__